export default __webpack_public_path__ + "assets/f941be9ea39e2505.jpg";